/* eslint-disable */

(function(W, D) {
	var autoComplete = (function () {
		// "use strict";
		function autoComplete(options) {
			if (!document.querySelector) return;

			// helpers
			function hasClass(el, className) { return el.classList ? el.classList.contains(className) : new RegExp('\\b' + className + '\\b').test(el.className); }

			function addEvent(el, type, handler) {
				if (el.attachEvent) el.attachEvent('on' + type, handler); else el.addEventListener(type, handler);
			}

			function removeEvent(el, type, handler) {
				// if (el.removeEventListener) not working in IE11
				if (el.detachEvent) el.detachEvent('on' + type, handler); else el.removeEventListener(type, handler);
			}

			function live(elClass, event, cb, context) {
				addEvent(context || document, event, function (e) {
					var found, el = e.target || e.srcElement;
					while (el && !(found = hasClass(el, elClass))) el = el.parentElement;
					if (found) cb.call(el, e);
				});
			}

			var o = {
				selector: 0,
				source: 0,
				minChars: 1,
				delay: 150,
				offsetLeft: 0,
				offsetTop: 1,
				cache: 1,
				menuClass: '',
				sections: [],
				renderItem: function (item, search) {
					// escape special characters
					search = search.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
					var re = new RegExp("(" + search.split(' ').join('|') + ")", "gi");
					return '<div class="autocomplete-suggestion" data-val="' + item + '">' + item.replace(re, "<b>$1</b>") + '</div>';
				},
				onSelect: function (e, term, item) { }
			};
			for (var k in options) { if (options.hasOwnProperty(k)) o[k] = options[k]; }

			// init
			var elems = typeof o.selector == 'object' ? [o.selector] : document.querySelectorAll(o.selector);
			for (var i = 0; i < elems.length; i++) {
				var that = elems[i];

				// create suggestions container "sc"
				that.sc = document.createElement('div');
				that.sc.className = 'autocomplete-suggestions ' + o.menuClass;

				that.autocompleteAttr = that.getAttribute('autocomplete');
				that.setAttribute('autocomplete', 'off');
				that.cache = {};
				that.last_val = '';

				that.updateSC = function (resize, next) {
					var rect = that.getBoundingClientRect();
					that.sc.style.left = Math.round(rect.left + (window.pageXOffset || document.documentElement.scrollLeft) + o.offsetLeft) + 'px';
					that.sc.style.top = Math.round(rect.bottom + (window.pageYOffset || document.documentElement.scrollTop) + o.offsetTop) + 'px';
					that.sc.style.width = Math.round(rect.right - rect.left) + 'px'; // outerWidth
					if (!resize) {
						that.sc.style.display = 'block';
						if (!that.sc.maxHeight) { that.sc.maxHeight = parseInt((window.getComputedStyle ? getComputedStyle(that.sc, null) : that.sc.currentStyle).maxHeight); }
						if (!that.sc.suggestionHeight) that.sc.suggestionHeight = that.sc.querySelector('.autocomplete-suggestion').offsetHeight;
						if (that.sc.suggestionHeight)
							if (!next) that.sc.scrollTop = 0;
							else {
								var scrTop = that.sc.scrollTop, selTop = next.getBoundingClientRect().top - that.sc.getBoundingClientRect().top;
								if (selTop + that.sc.suggestionHeight - that.sc.maxHeight > 0)
									that.sc.scrollTop = selTop + that.sc.suggestionHeight + scrTop - that.sc.maxHeight;
								else if (selTop < 0)
									that.sc.scrollTop = selTop + scrTop;
							}
					}
				}
				addEvent(window, 'resize', that.updateSC);
				document.body.appendChild(that.sc);

				live('autocomplete-suggestion', 'mouseleave', function (e) {
					var sel = that.sc.querySelector('.autocomplete-suggestion.selected');
					if (sel) setTimeout(function () { sel.className = sel.className.replace('selected', ''); }, 20);
				}, that.sc);

				live('autocomplete-suggestion', 'mouseover', function (e) {
					var sel = that.sc.querySelector('.autocomplete-suggestion.selected');
					if (sel) sel.className = sel.className.replace('selected', '');
					this.className += ' selected';
				}, that.sc);

				live('autocomplete-suggestion', 'mousedown', function (e) {
					if (hasClass(this, 'autocomplete-suggestion')) { // else outside click
						var v = this.getAttribute('data-val');
						that.value = v;
						o.onSelect(e, v, this);
						that.sc.style.display = 'none';
					}
				}, that.sc);

				that.blurHandler = function () {
					try { var over_sb = document.querySelector('.autocomplete-suggestions:hover'); } catch (e) { var over_sb = 0; }
					if (!over_sb) {
						that.last_val = that.value;
						that.sc.style.display = 'none';
						setTimeout(function () { that.sc.style.display = 'none'; }, 350); // hide suggestions on fast input
					} else if (that !== document.activeElement) setTimeout(function () { that.focus(); }, 20);
				};
				addEvent(that, 'blur', that.blurHandler);

				var suggest = function (data) {
					var val = that.value;

					that.cache[val] = data;

					if (data.length && val.length >= o.minChars) {
						var s = '';

						for (var i = 0; i < data.length; i++) {
							if (data[i] !== undefined) {
                                s += '<div class="autocomplete-suggestion-section">';

                                // If sections option is passed in, use the title
                                if (o.sections.length && o.sections[i] && o.sections[i].title) {
                                    s += '<div class="autocomplete-suggestion-section-header">' + o.sections[i].title + '<span class="section-results-length">' + data[i].length + '</span></div>';
                                }

                                if (data[i] && data[i].length) {
                                    for (var c = 0; c < data[i].length; c++) {
                                        s += o.renderItem(data[i][c], val);
                                    }
                                }

                                s += '</div>';
                            }
						}

						that.sc.innerHTML = s;
						that.updateSC(0);
					} else {
						console.log('no results');
						that.sc.style.display = 'none';
					}
				}

				that.keydownHandler = function (e) {
					var key = window.event ? e.keyCode : e.which;
					// down (40), up (38)
					if ((key == 40 || key == 38) && that.sc.innerHTML) {
						var options = [].slice.call(that.sc.querySelectorAll('.autocomplete-suggestion')),
							selected = that.sc.querySelector('.autocomplete-suggestion.selected'),
							next;

						this.sc.selectedIndex = selected ? options.indexOf(selected) : 0;

						if (! selected) {
							next = (key == 40) ? options[this.sc.selectedIndex] : options[options.length - 1];
							next.className += ' selected';
							that.value = next.getAttribute('data-val');
						} else {
							if (key == 40) { // down
								this.sc.selectedIndex++;
							} else if (key == 38) { // down
								this.sc.selectedIndex--;
							}

							next = options[this.sc.selectedIndex];

							if (next) {
								selected.className = selected.className.replace(' selected', '');
								next.className += ' selected';
								that.value = next.getAttribute('data-val');
							} else {
								selected.className = selected.className.replace(' selected', '');
								that.value = that.last_val;
								next = 0;
							}
						}

						that.updateSC(0, next);
						return false;
					}  else if (key == 27) { // esc
						that.value = that.last_val; that.sc.style.display = 'none';
					} else if (key == 13 || key == 9) { // enter
						var sel = that.sc.querySelector('.autocomplete-suggestion.selected');
						if (sel && that.sc.style.display != 'none') { o.onSelect(e, sel.getAttribute('data-val'), sel); setTimeout(function () { that.sc.style.display = 'none'; }, 20); }
					}
				};
				addEvent(that, 'keydown', that.keydownHandler);

				that.keyupHandler = function (e) {
					var key = window.event ? e.keyCode : e.which;
					if (!key || (key < 35 || key > 40) && key != 13 && key != 27) {
						var val = that.value;
						if (val.length >= o.minChars) {
							if (val != that.last_val) {
								that.last_val = val;
								clearTimeout(that.timer);
								if (o.cache) {
									if (val in that.cache) { suggest(that.cache[val]); return; }
									// no requests if previous suggestions were empty
									for (var i = 1; i < val.length - o.minChars; i++) {
										var part = val.slice(0, val.length - i);
										if (part in that.cache && !that.cache[part].length) { suggest([]); return; }
									}
								}
								that.timer = setTimeout(function () { o.source(val, suggest) }, o.delay);
							}
						} else {
							that.last_val = val;
							that.sc.style.display = 'none';
						}
					}
				};
				addEvent(that, 'keyup', that.keyupHandler);

				that.focusHandler = function (e) {
					that.last_val = '\n';
					that.keyupHandler(e)
				};
				if (!o.minChars) addEvent(that, 'focus', that.focusHandler);
			}

			// public destroy method
			this.destroy = function () {
				for (var i = 0; i < elems.length; i++) {
					var that = elems[i];
					removeEvent(window, 'resize', that.updateSC);
					removeEvent(that, 'blur', that.blurHandler);
					removeEvent(that, 'focus', that.focusHandler);
					removeEvent(that, 'keydown', that.keydownHandler);
					removeEvent(that, 'keyup', that.keyupHandler);
					if (that.autocompleteAttr)
						that.setAttribute('autocomplete', that.autocompleteAttr);
					else
						that.removeAttribute('autocomplete');
					document.body.removeChild(that.sc);
					that = null;
				}
			};
		}
		return autoComplete;
	})();

	function serialize(obj) {
		var str = [];

		for (var p in obj)
			if (obj.hasOwnProperty(p)) {
				str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
			}
		return str.join("&");
	}

	function request(options) {
		var xhttp = new XMLHttpRequest();

		xhttp.onreadystatechange = function () {
			if (this.readyState == 4 && this.status == 200) {
				if (typeof options.callback !== 'undefined') {
					try {
						var response = JSON.parse(this.responseText);
						options.callback(response);
					} catch (e) { }
				}
			}
		};

		if (typeof options.data !== 'undefined') {
			options.url += '?' + serialize(options.data);
		}

		xhttp.open('GET', options.url, true);
		return xhttp.send();
	}

	function SwiftypeSearch(options) {
		options = options || {};

		if (! options.engineKey) {
			console.error('SwiftypeSearch: You must supply an engine key');

			return;
		}

		if (! options.inputSelector) {
			console.error('SwiftypeSearch: You must supply an input selector');

			return;
		}

		var baseUrl = 'https://api.swiftype.com/api/v1/public/engines';
		var xhr;

		this.autoComplete = new autoComplete({
			selector: options.inputSelector,
			sections: options.sections,
			source: function(term, response) {
				request({
					url: baseUrl + '/' + 'suggest',
					data: {
						engine_key: options.engineKey,
						q: term
					},
					callback: function(data) {
						try { xhr.abort(); } catch (e) { }
						xhr = response([data.records.page, data.records.blogs]);
					}
				});
			},
			renderItem: function(item) {
				var title = item.highlight.title || item.title;

				return '<div class="autocomplete-suggestion" data-url="' + item.url + '">' + title + '</div>';
			},
			onSelect: function (e, term, item) {
				var url = item.getAttribute('data-url');

				if (url) {
					window.location = url;
				}
			}
		});
	}

	if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
		module.exports = SwiftypeSearch;
	} else {
		window.SwiftypeSearch = SwiftypeSearch;
	}
})(window, document);
